import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '../interfaces/country';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(private https: HttpClient) { }

  getCountries() {
    return this.https.get<Country[]>(environment.apiUrl + "countries");
  }
}
